/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdSlidesView200,
  GetApiV1ClassroomdisciplineIdSlidesView401,
  GetApiV1ClassroomdisciplineIdSlidesView404,
  GetApiV1ClassroomdisciplineIdSlidesViewPathParams,
  GetApiV1ClassroomdisciplineIdSlidesViewQueryParams,
  GetApiV1ClassroomdisciplineIdSlidesViewQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdSlidesView.ts";
import { slidesViewViewModelSchema } from "../slidesViewViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdSlidesViewPathParamsSchema = z.object(
  {
    id: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesViewPathParams>;

export const getApiV1ClassroomdisciplineIdSlidesViewQueryParamsSchema = z
  .object({
    culture: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesViewQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdSlidesView200Schema = z.lazy(
  () => slidesViewViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesView200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdSlidesView401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesView401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdSlidesView404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesView404>;

export const getApiV1ClassroomdisciplineIdSlidesViewQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdSlidesView200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesViewQueryResponse>;
